import * as d3 from 'd3'
import httpManager from "../../util/common"

export default {
    data() {
        return {
            report_date: '',
            industry: 'D44',
            report_date_options: [],
            carbon_data: [],
            bar_data: [],
            issubmit: false, // 防止连点
            no_data_show: false,
            loading: false,
            current_year: (new Date()).getFullYear(),
            current_month: (new Date()).getMonth()
        }
    },
    methods: {
        // 清除筛选条件
        clearOptions() {
            const { current_month, current_year } = this
            this.report_date = current_month <= 2 ? current_year - 2 : current_year - 1
            this.industry = 'D44'
            this.getCarbonData()
        },
        // 设置日期
        // 设置日期
        setReportDate() {
            const { current_month, current_year } = this
            this.report_date = current_month <= 2 ? current_year - 2 : current_year - 1
            this.report_date_options.push(current_year - 1)
            this.report_date_options.push(current_year - 2)
            this.report_date_options.push(current_year - 3)
            this.report_date_options.push(current_year - 4)
        },
        getCarbonData() {
            if(this.issubmit) return 
            this.issubmit = true
            this.no_data_show = false
            let self = this
            self.bar_data = []
            self.data = null
            let params = new Map()
            params.set("lang", this.$i18n.locale)
            if (self.report_date) {
                params.set("years", self.report_date)
            }
            params.set("page", 1)
            params.set("industry_pollution", self.industry)
            self.loading = true
            httpManager('carbon', params)
                .then(response => {
                    let array = response.data.data
                    self.carbon_data = array
                    if (array && array.length > 0) {
                        let promises = []
                        array.forEach(element => {
                            // let obj = { label: element.}
                            let oaid = element.oaid
                            let promise = self.setBarData(oaid, element.carbon_intensity)
                            promises.push(promise)
                        })
                        Promise.all(promises).then(result => {
                            self.drawBarChart()
                            self.issubmit = false
                        }).catch(error => {
                            self.issubmit = false
                        })
                    } else {
                        self.issubmit = false
                        self.no_data_show = true
                        self.drawBarChart()
                    }
                    self.loading = false
                }).catch(error => {
                    console.log(error)
                    self.issubmit = false
                    self.loading = false
                    self.drawBarChart()
                })
        },
        /* 
            通过oaid查询公司名称设置图表数据, value是当前oaid对应公司的碳排放量值
            返回值是promise
        */
        setBarData(oaid, value) {
            let self = this
            let params = new Map()
            params.set('oaid', oaid)
            let promise = httpManager('entity_basic_info', params)
                .then(response => {
                    let obj = {
                        label_zh: response.data.data.entname,
                        label_en: response.data.data.entname_en,
                        value: value
                    }
                    self.bar_data.push(obj)
                }).catch(error => {
                    console.log(error)
                })
            return promise
        },
        drawBarChart() {
            let data = this.bar_data.sort((a, b) => b.value - a.value)
            let margin = ({ top: 10, right: 10, bottom: 50, left: 50 })
            let width = 944
            let height = 343
            d3.select("#carbon-bar-chart-svg").select("svg").remove()
            var svg = d3.select("#carbon-bar-chart-svg").append("svg").attr("viewBox", [0, 0, width, height])
            var x_name = d3.scaleBand()
                .domain(this.bar_data.map(d => {
                    return d.label_zh.substring(0, 6) + '...'
                }))
                .rangeRound([margin.left, width - margin.right])
                .paddingInner(-1)
            var xAxis = g => g
                .attr("transform", `translate(0,${height - margin.bottom})`)
                .call(d3.axisBottom(x_name))
                .call(g => g.selectAll("line").remove())
                .call(g => g.select("path")
                    .attr("d", "M80,0.5H900")
                )
                .call(g => g.selectAll("text")
                    .attr("font-size", "12px")
                    .attr("color", "black")
                    .attr("transform", "translate(0,0)rotate(-20)")
                    .on('click', (e,d) => {
                        let company_name = ''
                        this.bar_data.forEach(element => {
                            if(element.label_zh.substring(0, 6) == d.substring(0, 6)) {
                                this.$router.push(`/entity/${element.label_zh}/home`)
                            }
                        })
                    })
                    .attr("style", "cursor: pointer;")
                )
            var x = d3.scaleBand()
                .domain(d3.range(this.bar_data.length))
                .range([margin.left, width - margin.right])
                .padding(1)

            if(data&&data.length > 0)
                var y = d3.scaleLinear()
                    .domain([0, d3.max(data, d => d.value)]).nice()
                    .range([height - margin.bottom, margin.top])
            else
                var y = d3.scaleLinear()
                    .domain([0, 100]).nice()
                    .range([height - margin.bottom, margin.top])
            var yAxis = g => g
                .attr("transform", `translate(${margin.left + 10},0)`)
                .call(d3.axisLeft(y).ticks(null, "s"))
                .call(g => g.selectAll(".domain").remove())
                .call(g => g.selectAll('line').remove())
                .call(g => g.selectAll('text')
                    .attr("font-weight", "400")
                    .attr("font-size", "15px"))

            let rect = svg.append("g")
                .attr("fill", "#b3282e")
                .selectAll("rect")
                .data(data)
                .join("rect")
                .attr("x", (d, i) => x(i))
                .attr("y", d => {
                    if (d.value) return y(d.value)
                    else return y(0)
                })
                .attr("height", d => {
                    if (d.value) return y(0) - y(d.value)
                    else return 0
                })
                .attr("width", 30)
            let text = svg.append("g")
                .attr("font-family", "sans-serif")
                .attr("font-size", 12)
                .attr("stroke-linecap", "round")
                .attr("stroke-linejoin", "round")
                .attr("text-anchor", "middle")
                .selectAll("text")
                .data(data)
                .join("text")
                .attr("dy", "0.35em")
                .attr("x", (d, i) => x(i) + 15)
                .attr("y", (d,i) => {
                    return d.value?y(d.value) - 5 : 0
                })
                .text(d => {
                    let k = d.value ? parseFloat(d.value.toFixed(2)): ''
                    return d.value ? k.toLocaleString(): ""
                })
            svg.append("g").call(xAxis)
            svg.append("g").call(yAxis)
        }
    },
    created() {
        this.setReportDate()
    },
    mounted() {
        this.getCarbonData()
    },
    computed: {
        carbon_industry_options() {
            return [
                { label: this.$t('carbon.generate_electricity'), value: 'D44' },
                { label: this.$t('carbon.iron_steel'), value: 'C31' },
                { label: this.$t('carbon.chemical'), value: 'C26' },
                { label: this.$t('carbon.building_materials'), value: 'C30' },
                { label: this.$t('carbon.civil_aviation'), value: 'G56' },
                { label: this.$t('carbon.petrochemical'), value: 'C25' },
                { label: this.$t('carbon.colored'), value: 'C32' },
                { label: this.$t('carbon.papermaking'), value: 'C22' },
            ]
        },
    }
}


// WEBPACK FOOTER //
// ./src/carbon/js/carbon_bar_chart.js